import { Box, Divider, Link, Typography } from '@mui/material'
import { FC, useMemo } from 'react'
import { DetailRow } from './DetailRow'
import { Location } from '../../api/models'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { MISSING_VALUE } from '../../constants'

interface LocationDetailsProps {
  location: Location
  propertyType?: string
  supportHubUrl?: string
}

export const LocationDetails: FC<LocationDetailsProps> = ({ location, propertyType, supportHubUrl }) => {
  const addressLines = useMemo(() => {
    const lines: string[] = []
    if (location) {
      const { street1, street2, city, state, zip } = location.address ?? {}
      lines.push(street1 || MISSING_VALUE)
      if (street2) {
        lines.push(street2)
      }
      lines.push(`${city || MISSING_VALUE}, ${state || MISSING_VALUE} ${zip || MISSING_VALUE}`)
    }
    return lines
  }, [location])

  return (
    <Box>
      <DetailRow label="Location" value={location.name} />
      <DetailRow label="Type" value={propertyType} />
      <DetailRow label="Address" value={addressLines} />
      <DetailRow label="County" value={location?.address?.county} />
      <Divider sx={{ bgcolor: 'var(--shape-info-var)', my: 1 }} />
      <DetailRow label="Base Station Serial #" value={location?.baseStationSerialNumber} />
      <DetailRow label="SID" value={location?.id} />
      <DetailRow label="UID" value={location?.user.userId ? String(location.user.userId) : ''} />
      <DetailRow label="Email" value={location?.user?.emailAddress} />
      <Divider sx={{ bgcolor: 'var(--shape-info-var)', my: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-2xs)' }}>
        <Typography fontSize="var(--size-2xs)" fontWeight={300}>
          Go to
        </Typography>
        <Link
          target="_blank"
          href={supportHubUrl || '#'}
          sx={{
            fontSize: 'var(--size-2xs)',
            fontWeight: 300,
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'underline',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          SupportHub
          <ArrowForwardIcon sx={{ fontSize: 'var(--size-2xs)', ml: 0.5 }} />
        </Link>
      </Box>
    </Box>
  )
}
